import {ToggleButtonWithTitle} from '@gongxigames/framework/core/fragments/react';
import React from 'react';

type AutoplayRoundsSelectorOptionProps = {
    value: number;
    selected: boolean;
    onToggle: (value: number) => void;
    isNotValid?: boolean;
    size: {width: number; height: number;};
    name?: string;
};

export function AutoplayRoundsSelectorOption(props: AutoplayRoundsSelectorOptionProps): JSX.Element {
    const {selected, value, onToggle, isNotValid, size, name} = props;
    const onBackground = {backgroundColor: isNotValid ? 0xff0000 : 0x838383};
    const offBackground = {backgroundColor: isNotValid ? 0xff0000 : 0x555555};

    return (
        <ToggleButtonWithTitle
            name={name}
            onBackground={onBackground}
            offBackground={offBackground}
            round={20}
            width={size.width}
            height={size.height}
            onToggle={() => onToggle(value)}
            title={value.toString()}
            value={selected}
            textStyleId={'AutoplayPopupRoundsOptionText'}
        />
    );
}
